<template>
	<section class="content">
		<div class="card">
			<div class="overlay" v-if="loading"><h1 style="font-size:40px;">Sedang diproses <i class="fas fa-sync-alt fa-spin"></i></h1></div>
			<div class="card-body">
				<div class="row mb-3 justify-content-end" style="row-gap: .5rem;">
					<div class="col-12 col-sm-auto mr-auto" :class="{ 'mr-sm-0' : false }">
						<select class="form-control" required v-model="filter.tipe_rekan" @change="dataTable.api().ajax.reload()">
							<option :value="null" selected disabled hidden>Tipe Rekan</option>
							<option v-for="tipe in listTipe" v-bind:key="tipe.id" v-bind:value="tipe.id">
								{{ tipe.label }}
							</option>
						</select>
					</div>
					<div class="col col-sm-auto text-right">
						<div class="btn-group" ref="toolbar">
							<button type="button" data-action="read" class="btn btn-primary border-right-0" v-if="false">
								<i class="fi fi-rr-refresh d-flex"></i>
							</button>
							<button type="button" :disabled="loading" v-on:click="showForm" data-action="export-xlsx" class="btn btn-primary">
								Tambah Rekan
							</button>
						</div>
					</div>
				</div>

				<table class="table table-hover row-border" ref="tableRiwayatRekonsiliasi" id="tableRiwayatRekonsiliasi">
					<thead>
						<tr>
							<th>
								<input type="checkbox" id="checkall" ref="checkall" name="checkall" value="1" @click="selectAll" />
							</th>
							<th>ID Rekan</th>
							<th>Tipe Rekan</th>
							<th>Nama Rekan</th>
							<th>Alamat Rekan</th>
							<th>Aksi</th>
						</tr>
					</thead>
					<tbody @click="handleClick">
					</tbody>
				</table>
			</div>
		</div>

		<div class="modal" tabindex="-1" role="dialog" ref="formDialog" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<form @submit.prevent="submitForm($event)">
						<div class="modal-header">
							<h5 class="modal-title font-weight-bold">Buat Data Rekanan</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="h6 font-weight-bold pb-2 border-bottom mb-3">Data Rekanan</div>
							<div class="row">
								<div class="col-12 col-sm-6">
									<div class="form-group">
										<label class="font-weight-normal">ID Rekan</label>
										<input type="text" min="0" id="code" class="form-control" v-model="form.code" placeholder="0108202310" :disabled="form.id != null || form.tipe_rekan != 1" required />
									</div>
								</div>
								<div class="col-12 col-sm-6">
									<div class="form-group">
										<label class="font-weight-normal">Tipe Rekan</label>
										<select id="tipe_rekan" class="form-control" v-model="form.tipe_rekan" required>
											<option :value="null" selected disabled hidden>Pilih tipe rekan</option>
											<option v-for="tipe in listTipe" v-bind:key="tipe.id" v-bind:value="tipe.id">
												{{ tipe.label }}
											</option>
										</select>
									</div>
								</div>
								<div class="col-12 col-sm-12">
									<div class="form-group">
										<label class="font-weight-normal">Nama Rekan</label>
										<input type="text" id="nama_rekan" class="form-control" v-model="form.nama_rekan" placeholder="Masukkan nama rekan" required />
									</div>
								</div>
								<div class="col-12 col-sm-12">
									<div class="form-group">
										<label class="font-weight-normal">Alamat Rekan</label>
										<textarea id="address" class="form-control" v-model="form.address" placeholder="Masukkan alamat rekan" required></textarea>
									</div>
								</div>
								<div class="col-12 col-sm-6">
									<div class="form-group">
										<label class="font-weight-normal">Masukkan Nomor NPWP <span class="text-secondary" ref="btntoolTip1" @mouseover="mouseOver1" data-toggle="tooltip" data-placement="top" data-html="true" title="<b>Tidak wajib</b> memasukkan nomor NPWP"><i class="fi fi-rr-info"></i></span></label>
										<input type="number" id="npwp" class="form-control" v-model="form.npwp" placeholder="Masukkan nomor npwp" />
									</div>
								</div>
								<div class="col-12 col-sm-6">
									<div class="form-group">
										<label class="font-weight-normal">Masukkan Alamat Email <span class="text-secondary" ref="btntoolTip2" @mouseover="mouseOver2" data-toggle="tooltip" data-placement="top" data-html="true" title="<b>Tidak wajib</b> memasukkan alamat email"><i class="fi fi-rr-info"></i></span></label>
										<input type="email" id="email_rekan" class="form-control" v-model="form.email_rekan" placeholder="Masukkan alamat email" />
									</div>
								</div>
							</div>
							<div class="h6 font-weight-bold pb-2 border-bottom my-3">Informasi PIC</div>
							<div class="row">
								<div class="col-12 col-sm-6">
									<div class="form-group">
										<label class="font-weight-normal">Nama PIC</label>
										<input type="text" id="nama_pic" class="form-control" v-model="form.nama_pic" placeholder="Masukkan nama PIC" required />
									</div>
								</div>
								<div class="col-12 col-sm-6">
									<div class="form-group">
										<label class="font-weight-normal">No. Telepon</label>
										<input type="tel" min="0" id="telp_pic" class="form-control" v-model="form.telp_pic" placeholder="Masukkan no telepon" required />
									</div>
								</div>
							</div>
							<div class="h6 font-weight-bold pb-2 border-bottom my-3">Informasi Bank Rekanan</div>
							<div class="row">
								<div class="col-12 col-sm-6">
									<div class="form-group">
										<label class="font-weight-normal">Nama Bank</label>
										<select id="nama_bank" class="form-control" v-model="form.nama_bank" required >
											<option :value="null" selected disabled hidden>Pilih bank</option>
											<option v-for="bank in listBank" v-bind:key="bank.id" v-bind:value="bank.label">
												{{ bank.label }}
											</option>
										</select>
									</div>
								</div>
								<div class="col-12 col-sm-6">
									<div class="form-group">
										<label class="font-weight-normal">No. Rekening</label>
										<input type="number" min="0" id="no_rekening" class="form-control" v-model="form.no_rekening" placeholder="Masukkan no rekening" required />
									</div>
								</div>
								<div class="col-12 col-sm-12">
									<div class="form-group">
										<label class="font-weight-normal">Nama Pemilik Rekening</label>
										<input type="text" id="rekening_atasnama" class="form-control" v-model="form.rekening_atasnama" placeholder="Masukkan nama pemilik rekening" required />
									</div>
								</div>
								<div class="col-12 col-sm-12">
									<div class="form-group">
										<label class="font-weight-normal">Catatan Tambahan (opsional)</label>
										<textarea id="catatan" class="form-control" v-model="form.catatan" placeholder="Tulis catatan tambahan"></textarea>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-outline-primary" data-dismiss="modal">Batalkan</button>
							<button type="submit" class="btn btn-primary" :disabled="loading">Simpan <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</section>
	<!-- /.content -->
</template>
<script>
import { auth, authFetch, createTable } from "@/libs/hxcore";
import $ from "jquery";
import Swal from "sweetalert2";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "icheck-material";

export default {
	name: "Rekanan",
	data() {
		return {
			listTipe: [
				{
					id: '1',
					label: 'Kurir'
				},
				{
					id: '0',
					label: 'Internal'
				},
				{
					id: '2',
					label: 'Eksternal'
				}
			],
			showTipe: [
				'Internal',
				'Kurir',
				'Eksternal'
			],
			listBank: [],
			loading: false,
			errors: [],
			method: "",
			roles: "",
			filter: {
				tipe_rekan: null
			},
			form: {
				id: null,
				code: null,
				tipe_rekan: null,
				nama_rekan: null,
				address: null,
				npwp: null,
				email_rekan: null,
				nama_pic: null,
				telp_pic: null,
				nama_bank: null,
				no_rekening: null,
				rekening_atasnama: null,
				catatan: null
			}
		};
	},
	computed: {},
	components: {
		vSelect,
	},
	watch:{
		form: {
			handler(val) {
				if (val.tipe_rekan != 1 && val.id == null) {
					this.form.code = null;
				}
			},
			deep: true
		}
	},
	created: function () {
		this.roles = this.$route.meta.roles;
		this.userInfo = auth.user();

		authFetch("/shipper/member_type").then(res => {
			res.json().then((json) => {
				this.listMember = json.data;
			});
		});
	},
	methods: {
		getImage(file) {
			return require(`../../assets/img/${file}.svg`);
		},
		handleClick: async function(e) {
			if (e.target.matches("input[type=checkbox]")) {
				var checkboxes = document.querySelectorAll('.select-rekanan:checked');
				if (checkboxes.length == 0) {
					this.$refs.checkall.checked = false;
				} else {
					this.$refs.checkall.checked = true;
				}

				this.selectedCount = checkboxes.length;
				if (this.selectedCount > 0) {
					$(this.$refs.btnSelected).show();
				} else {
					$(this.$refs.btnSelected).hide();
				}
				return false;
			} else if (e.target.dataset.action == "edit") {
				var nRow = $(e.target).closest("tr").get(0);
				var iRow = this.dataTable.fnGetPosition(nRow);
				var aData = this.dataTable.fnGetData(iRow);

				this.form = aData;
				$(this.$refs.formDialog).modal("show");

				if (this.listBank.length == 0) {
					authFetch("/shipper/bank").then(res => {
						res.json().then((json) => {
							this.listBank = json.data;
						});
					});
				}
			} else if (e.target.dataset.action == "delete") {
				this.loading = true;
				await this.customSwal.fire({
					html: '<img src="' + this.getImage('warning') + '" class="d-block swal2-img mx-auto mb-3" /><div class="h5">Yakin ingin menghapus data?</div>',
					showConfirmButton: status != 1,
					showDenyButton: status != 1,
					showCancelButton: status == 1,
					confirmButtonText: 'Hapus',
					denyButtonText: 'Batal',
					cancelButtonText: 'Oke'
				})
				.then((result) => {
					if (result.isConfirmed) {
						authFetch('/master/rekanan', {
							method: 'DELETE',
							body: 'id=' + e.target.dataset.id
						})
						.then((res) => {
							if (res.status === 201) {} else if (res.status === 400) {}
							return res.json();
						})
						.then((js) => {
							this.customSwal.fire({
								html: '<img src="' + this.getImage(js.success ? 'ok' : 'overload') + '" class="swal2-img d-block mx-auto mb-3" /><div class="h5">' + (js.success ? js.message : js.type == 'error_input' ? 'Data tidak lengkap' : 'Terjadi kesalahan') + '</div><div class="w-75 m-auto" style="max-height: 100px;overflow-y: scroll;">' + (js.details ? '<ul class="text-left"><li>' + Object.keys(js.details).map(key => js.details[key]).join('</li><li>') + '</li></ul>' : '') + '</div>',
								showConfirmButton: false,
								showCancelButton: true,
								cancelButtonText: js.success ? 'Oke' : 'Coba lagi'
							})
							.then((js) => {
								this.loading = false;
								this.dataTable.api().ajax.reload();
							});
						});
					} else {
						this.loading = false;
					}
				});
			}
		},
		showForm() {
			if (this.form.id != null) {
				this.resetForm();
			}

			$(this.$refs.formDialog).modal("toggle");

			if (this.listBank.length == 0) {
				authFetch("/shipper/bank").then(res => {
					res.json().then((json) => {
						this.listBank = json.data;
					});
				});
			}
		},
		selectAll: function (e) {
			var val = e.target.checked;
			var checkboxes = document.querySelectorAll('.select-rekon');

			for (var i = 0; i < checkboxes.length; i++) {
				checkboxes[i].checked = val;
			}

			if (val && checkboxes.length > 0) {
				this.selectedCount = checkboxes.length;
			} else {
				this.selectedCount = 0;
			}

			if (this.selectedCount > 0) {
				$(this.$refs.btnSelected).show();
			} else {
				$(this.$refs.btnSelected).hide();
			}
		},
		mouseOver1: function(e){
			let ev = this.$refs;
			$(ev.btntoolTip1).tooltip('show');
		},
		mouseOver2: function(e){
			let ev = this.$refs;
			$(ev.btntoolTip2).tooltip('show');
		},
		submitForm: function(event) {
			this.loading = true;
			authFetch('/master/rekanan', {
				method: this.form.id == null ? 'POST' : 'PUT',
				body: Object.keys(this.form).map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(this.form[key] == null ? '' : this.form[key])).join("&")
			})
			.then(res => {
				if (res.status === 201) {} else if (res.status === 400) {}
				return res.json();
			})
			.then(js => {
				this.loading = false;
				this.customSwal.fire({
					html: '<img src="' + this.getImage(js.success ? 'ok' : 'overload') + '" class="swal2-img d-block mx-auto mb-3" /><div class="h5">' + (js.success ? js.message : js.type == 'error_input' ? 'Data tidak lengkap' : 'Terjadi kesalahan') + '</div><div class="w-75 m-auto" style="max-height: 100px;overflow-y: scroll;">' + (js.details ? '<ul class="text-left"><li>' + Object.keys(js.details).map(key => js.details[key]).join('</li><li>') + '</li></ul>' : '') + '</div>',
					showConfirmButton: false,
					showCancelButton: true,
					cancelButtonText: js.success ? 'Kembali' : 'Coba lagi'
				}).then((result) => {
					if (js.success && result.isDismissed) {
						this.resetForm();
						$(this.$refs.formDialog).modal("toggle");
						this.dataTable.api().ajax.reload();
					}
				});
			});
            this.errors = [];
			event.preventDefault();
		},
		resetForm() {
			this.form.id = null;
			this.form.code = null;
			this.form.tipe_rekan = null;
			this.form.nama_rekan = null;
			this.form.address = null;
			this.form.npwp = null;
			this.form.email_rekan = null;
			this.form.nama_pic = null;
			this.form.telp_pic = null;
			this.form.nama_bank = null;
			this.form.no_rekening = null;
			this.form.rekening_atasnama = null;
			this.form.catatan = null;
		}
	},
	mounted() {
		const e = this.$refs;
		var self = this;

		this.dataTable = createTable(e.tableRiwayatRekonsiliasi, {
			title: "",
			roles: this.$route.params.roles,
			ajax: "/master/rekanan",
			frame: false,
			toolbarEl: e.toolbar,
			fixedColumns: {
				start: 1,
				end: 1
			},
			scrollCollapse: true,
			scrollX: true,
			processing: true,
			autoWidth:false,
			language: {
				processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'
			},
			filterBy: [1, 3, 4],
			order: [[0, 'desc']],
			paramData: function (d) {
				var filter = JSON.parse(JSON.stringify(self.filter));
				for (const key in filter) {
					d[key] = filter[key] === false ? 0 : filter[key];
				}
			},
			columns: [
				{
					data: "id",
					render: function (data, type, row, meta) {
						return `<input type="checkbox" class="select-rekanan" value="` + data + `" />`
					},
					visible: false
				},
				{ data: "code" },
				{
					data: "tipe_rekan",
					render: function (data, type, row, meta) {
						if (self.showTipe[data]) {
							return self.showTipe[data];
						} else {
							return '';
						}
					}
				},
				{ data: "nama_rekan" },
				{ data: "address" },
				{
					data: "id",
					sortable: false,
					render: function (data, type, row, meta) {
						return `<div class="d-inline-flex align-items-center justify-content-around w-100">
							<i class="fi fi-rr-edit text-warning text-lg cursor-pointer" data-action="edit" data-id="${data}"></i>
							<i class="fi fi-rr-trash text-danger text-lg cursor-pointer" data-action="delete" data-id="${data}"></i>
						</div>`;
					}
				}
			],
			rowCallback: function (row, data) {
			},
			initComplete: function () {
				$('.loading-overlay').removeClass('show');
			},
		});

		this.customSwal = Swal.mixin({
			customClass: {
				content: 'p-0',
				title: 'h4 tex-dark',
				input: 'form-control',
				actions: 'd-flex justify-content-between flex-row-reverse',
				confirmButton: 'btn btn-primary col font-weight-bold',
				denyButton: 'btn btn-outline-primary col font-weight-bold',
				cancelButton: 'btn btn-primary w-75 font-weight-bold m-auto',
			},
			buttonsStyling: false
		});
	},
};
</script>
<style type="text/css">
</style>